/* eslint-disable */ 
import { PieChart, Pie, Cell, Tooltip } from 'recharts';
import "../../../../../styles/ComponentsStyles/Organizational/Management/Staffs/PieChart.style.css";
import PropTypes from 'prop-types';

const PieChartComponent = ({ data }) => {
    // Calculate the total attendance for all categories
    const CustomTooltip = ({ active, payload, label, coordinate }) => {
        if (active && payload && payload.length) {
            const entry = payload[0].payload; // Access the data entry
            const percentage = ((entry.totalAttandence / entry.totalPerson) * 100).toFixed(2);

            // Adjust tooltip position to appear above the pie chart segment
            const tooltipX = coordinate ? coordinate.x - 50 : 0; // Center the tooltip horizontally
            const tooltipY = coordinate ? coordinate.y - 80 : 0; // Position above the segment

            return (
                <div
                    className="customToolTip"
                    style={{
                        position: 'absolute',
                        top: `${tooltipY}px`,
                        left: `${tooltipX}px`,
                        backgroundColor: 'white',
                        textAlign: 'center',
                    }}
                >
                    <p>{percentage}%</p>
                    <p>{entry.name}</p>
                </div>
            );
        }
        return null;
    };

    const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, index }) => {
        const RADIAN = Math.PI / 180;
        const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
        const x = cx + radius * Math.cos(-midAngle * RADIAN);
        const y = cy + radius * Math.sin(-midAngle * RADIAN);

        const dataEntry = data[index];

        return (
            <text style={{ fontFamily: "Poppins-Regular", fontSize: "10px", width: "100%", padding: "3px" }} x={x} y={y} fill="white" textAnchor="middle" dominantBaseline="central">
                {dataEntry.name.charAt(0) + "-" + dataEntry.totalAttandence + "/" + dataEntry.totalPerson}
            </text>
        );
    };

    return (
        <div className="pieChart">
            <PieChart width={450} height={450}>
                <Pie
                    data={data}
                    cx="50%"
                    cy="50%"
                    outerRadius={120}
                    fill="#8884d8"
                    dataKey={(entry) => (entry.totalAttandence / entry.totalPerson) * 100} // Calculate percentage dynamically
                    label={renderCustomizedLabel}
                    labelLine={false}
                >
                    {data.map((entry, index) => (
                        <Cell key={`cell-${index}`} fill={entry.color} />
                    ))}
                </Pie>
                <Tooltip content={<CustomTooltip />} cursor={false} />
            </PieChart>
        </div>
    );
};

export default PieChartComponent;

PieChartComponent.propTypes = {
    data: PropTypes.array.isRequired
}